/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input } from 'reactstrap';
import Icon from "../../../../common/icon";
import 'bootstrap-slider/dist/css/bootstrap-slider.css';

/**
 * Time slider (simple)
 * Time range slider (simple choix : plage horaire)
 *
 * On enregistre 3 valeurs (min, mid, max)
 *
 * @see https://github.com/brownieboy/react-bootstrap-slider
 */
var FixedInput = function FixedInput(props) {
  var onChangeValue = props.onChangeValue,
    value = props.value,
    type = props.type;
  var updateHour = function updateHour(e) {
    var result = e.target.value.split(':')[0] + 'h' + e.target.value.split(':')[1];
    onChangeValue({
      min: result,
      max: result,
      mid: result
    }, type);
  };
  return /*#__PURE__*/React.createElement(Row, {
    className: "d-flex justify-content-center",
    style: {
      width: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Col, {
    className: "tag align-self-center timerInput"
  }, /*#__PURE__*/React.createElement(Input, {
    className: "input-time-center",
    value: value && value.mid ? value.mid.split('h')[0] + ':' + value.mid.split('h')[1] : '00:00',
    onChange: function onChange(e) {
      updateHour(e);
    },
    type: "time"
  })));
};
FixedInput.propTypes = {
  onChangeValue: PropTypes.func.isRequired
};
FixedInput.defaultProps = {
  responses: {}
};
export default FixedInput;